import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { getInitialStyle } from './password.style';
import { getPasswordString } from './password.utils';
import { RestrictedInput } from '../../../tornado/restrictedInput/restrictedInput.component';
import { PASSWORD_LENGTH } from '../kidsLeavePopup.constant';

export class Password extends Lightning.Component {
  static _template() {
    return _merge(
      {
        TextPassword: {
          text: { text: '' },
        },
        InputPassword: {
          type: RestrictedInput,
        },
      },
      getInitialStyle(),
    );
  }

  _init() {
    this.tag('InputPassword').length = PASSWORD_LENGTH;
  }

  push(digit) {
    this.tag('InputPassword').push(digit);
  }

  pop() {
    this.tag('InputPassword').pop();
  }

  clearPasswordInput() {
    this.tag('InputPassword').clearInput();
  }

  set borderCellColor(color) {
    this.tag('InputPassword').borderCellColor = color;
  }

  set cells(length) {
    this.tag('InputPassword').length = length;
  }

  setPasswordText(value) {
    const text = getPasswordString(value);
    this.tag('TextPassword').visible = Boolean(text);
    this.tag('TextPassword').text.text = text;
  }
}
